import React from "react";
import { Field } from "formik";
import { TextField } from "@material-ui/core";

const TemperatureAndMaxFields = ({ touched, errors, classes, labelTemp, labelMaxTokens, labelMaxMessages }) => (
  <>
    <div className={classes.multFieldLine}>
      <Field
        as={TextField}
        label={labelTemp}
        name="temperature"
        type="number"
        fullWidth
        margin="dense"
        inputProps={{ step: "0.1", min: "0", max: "1" }}
        error={touched.temperature && Boolean(errors.temperature)}
        helperText={touched.temperature && errors.temperature}
      />
        <Field
        as={TextField}
        label={labelMaxTokens}
        name="maxTokens"
        fullWidth
        margin="dense"
        error={touched.maxTokens && Boolean(errors.maxTokens)}
        helperText={touched.maxTokens && errors.maxTokens}
      />
      <Field
        as={TextField}
        label={labelMaxMessages}
        name="maxMessages"
        fullWidth
        margin="dense"
        error={touched.maxMessages && Boolean(errors.maxMessages)}
        helperText={touched.maxMessages && errors.maxMessages}
      />
    </div>
  </>
);

export default TemperatureAndMaxFields;
